import { OrderForm } from '@dgx-pr-spa/shared/util';
import { createReducer, on } from '@ngrx/store';
import * as fromOrderForm from '../actions/order.form.action';
import { StateSlice } from '@core/helpers/state-slice';

export type OrderFormState = StateSlice<OrderForm>;

export const initialState: OrderFormState = {
  data: {} as OrderForm,
  loaded: false,
  loading: false,
  error: null,
};

const orderFormReducer = createReducer(
  initialState,
  on(fromOrderForm.updateForm, (state, { payload }) => {
    return {
      ...state,
      loading: false,
      loaded: true,
      data: payload,
    };
  })
);

export function reducer(
  state: OrderFormState | undefined,
  action: fromOrderForm.OrderFormActions
) {
  return orderFormReducer(state, action);
}
